import { gql } from "@grandvisionhq/graphql";
const addressFragment = gql`
  fragment AddressFragment on OrderAddress {
    city
    countryCode
    streetName
    streetNumber
    additionalStreetInfo
    additionalAddressInfo
    apartment
    company
    email
    firstName
    middleName
    lastName
    mobile
    phone
    pOBox
    postalCode
    region
    state
    title
    externalId
    salutation
  }
`;
const orderPriceFragment = gql`
  fragment OrderPriceFragment on OrderPrice {
    currencyCode
    final {
      subtotal
      gross
      discount {
        amount
        appliedDiscounts {
          type
          amount
        }
      }
      tax {
        amount
        portions {
          rate
        }
      }
    }
    priceBeforeCosts {
      subtotal
      gross
      discount {
        amount
      }
    }
    shippingCost {
      gross
      discount {
        amount
      }
      tax {
        amount
        portions {
          rate
        }
      }
    }
    paymentCost {
      gross
    }
    donation
    finalWithDonation
  }
`;
const orderCustomerDetailsFragment = gql`
  fragment OrderCustomerDetailsFragment on OrderCustomerDetails {
    phone
    email
    dateOfBirth
    code
    IBAN
  }
`;
const orderInvoiceDetailsFragment = gql`
  fragment OrderInvoiceDetailsFragment on OrderInvoiceDetails {
    certifiedEmail
    vatId
    code
    certifiedRecipientCode
    insuranceProvider
    insuranceNumber
  }
`;
const orderPaymentFragment = gql`
  fragment OrderPaymentFragment on Payment {
    paymentMethodDetails {
      ... on VoucherDetails {
        expiresAt
        externalId
        externalReference
      }
      ... on CreditCardDetails {
        type
      }
    }
    donationIntent {
      foundationKey
    }
  }
`;
export {
  addressFragment,
  orderCustomerDetailsFragment,
  orderInvoiceDetailsFragment,
  orderPaymentFragment,
  orderPriceFragment
};
//# sourceMappingURL=order-details.js.map
